import * as authActions2 from '../../actions/auth/authWithOtp/authActions2';
let lock = false;

const refreshToken = store => next => action => {
  const result = next(action);

  const state = store.getState();
  const dispatch = store.dispatch;
  if (state.auth.loginData && !state.auth.isAuthenticating) {
    const loginData = state.auth.loginData;
    const timeSinceLogin = Date.now() - loginData.date;
    if (timeSinceLogin > loginData.expires_in * 1000 / 2) {
      if(!lock) {
        lock = true;
        setTimeout(
          () => {
            const timeBetweenRefresh = timeSinceLogin - (loginData.expires_in * 1000);
            const elapsedHours = timeBetweenRefresh / 1000 / 60 / 60;
            dispatch(authActions2.loginWithRefreshToken(loginData.refresh_token, elapsedHours));
            lock = false;
          }
        );
      }
    }
  }

  return result;
};

export default refreshToken;



// WEBPACK FOOTER //
// ./src/store/middleware/refreshToken.js